// extracted by mini-css-extract-plugin
export default {"titleContainer":"titleContainer___gKbqj","title":"title___qrEhL","count":"count___iuqI0"};